import React from 'react';
import {useSelector} from 'react-redux';

import {RootState} from '../store';
import {TabScreens} from '../routes';
import {components} from '../components';

import {Home} from '../screens/tabs/Home';
import {Menu} from '../screens/tabs/Menu';
// import {Order} from '../screens/tabs/Order';
import {FeeDetails} from '../screens/tabs/FeeDetails';
import {History} from '../screens/tabs/History';
import {Academy} from '../screens/tabs/Academy';
import {Notification} from '../screens/tabs/Notification';

import { AdminDashboard } from '../screens/tabs/AdminDashboard';

export const TabNavigator: React.FC = () => {
  const currentTabScreen = useSelector(
    (state: RootState) => state.tabSlice.screen,
  );

  const renderTitle = (): string => {
    switch (currentTabScreen) {
      case TabScreens.Home:
        return '';
      case TabScreens.Menu:
        return '';
      case TabScreens.Admin:
        return 'Admin Dashboard';
      case TabScreens.FeeDetails:
        return 'Fee Details';
      case TabScreens.History:
        return 'Riwayat';
      case TabScreens.Academy:
        return 'Academy';
      case TabScreens.Notification:
        return 'Notifications';
      default:
        return 'Home';
    }
  };

  const renderScreens = (): JSX.Element | null => {
    switch (currentTabScreen) {
      case TabScreens.Home:
        return <Home />;
      case TabScreens.Menu:
        return <Menu />;
      case TabScreens.FeeDetails:
        return <FeeDetails />;
      case TabScreens.Admin:
        return <AdminDashboard />;
      case TabScreens.History:
        return <History />;
      case TabScreens.Academy:
        return <Academy />;
      case TabScreens.Notification:
        return <Notification />;
      default:
        return null;
    }
  };

  const renderUserPhoto = (): boolean => {
    switch (currentTabScreen) {
      case TabScreens.Home:
        return true;
      case TabScreens.Menu:
        return true;
      case TabScreens.FeeDetails:
        return true;
      case TabScreens.History:
        return true;
      case TabScreens.Admin:
        return true;
      case TabScreens.Academy:
        return true;
      case TabScreens.Notification:
        return true;
      default:
        return false;
    }
  };

  const renderUserName = (): boolean => {
    switch (currentTabScreen) {
      case TabScreens.Home:
        return true;
      case TabScreens.Menu:
        return true;
      case TabScreens.FeeDetails:
        return false;
      case TabScreens.Admin:
        return false;
      case TabScreens.History:
        return false;
      case TabScreens.Academy:
        return false;
      case TabScreens.Notification:
        return false;
      default:
        return false;
    }
  };

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        showBasket={true}
        title={renderTitle()}
        userName={renderUserName()}
        userPhoto={renderUserPhoto()}
      />
    );
  };

  const renderFooter = (): JSX.Element => {
    return <components.Footer />;
  };

  return (
    <>
      {renderHeader()}
      {renderScreens()}
      {renderFooter()}
    </>
  );
};
